module.exports = __webpack_public_path__ + "statics/img/12.4327e6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/12.png
// module id = nbhp
// module chunks = 1